module.exports = __webpack_public_path__ + "img/product_bg_new_04.b2a7d02.png";